/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Portal_KcalInputs */

const en_portal_kcal = /** @type {(inputs: Portal_KcalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount} kcal`)
};

const pl_portal_kcal = /** @type {(inputs: Portal_KcalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount} kcal`)
};

/**
* | output |
* | --- |
* | "{amount} kcal" |
*
* @param {Portal_KcalInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_kcal = /** @type {((inputs: Portal_KcalInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_KcalInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_kcal(inputs)
	return en_portal_kcal(inputs)
});